
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { enhancedToast } from '@/utils/notifications/enhancedToast';
import { UsersRound, LayoutDashboard, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTimetableData } from '../hooks/useTimetableData';
import AttendanceList from '../components/attendance/AttendanceList';
import AttendanceReport from '../components/attendance/AttendanceReport';

const TeacherAttendance = () => {
  const navigate = useNavigate();
  const { timetableData, isLoading, error, refreshData } = useTimetableData();
  
  useEffect(() => {
    // Auto-refresh once on component mount
    refreshData().catch(error => {
      console.error("Error refreshing timetable data:", error);
    });
  }, [refreshData]);

  if (isLoading) {
    return (
      <div className="p-8 flex flex-col items-center justify-center">
        <div className="h-12 w-12 rounded-full border-4 border-primary border-t-transparent animate-spin mb-4"></div>
        <p>Loading attendance data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8 text-center">
        <div className="text-red-500 mb-4">Error loading data: {error.message}</div>
        <Button onClick={refreshData} variant="outline" className="flex items-center">
          <RefreshCw className="mr-2 h-4 w-4" />
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div className="container p-4 mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-primary flex items-center">
            <UsersRound className="mr-2 h-6 w-6" />
            Teacher Attendance
          </h1>
          <p className="text-muted-foreground mt-1">
            Track teacher attendance and view class schedule impacts
          </p>
        </div>
        <div className="flex space-x-3">
          <Button
            variant="outline"
            size="sm"
            className="flex items-center"
            onClick={() => navigate('/teachers')}
          >
            <UsersRound className="mr-2 h-4 w-4" />
            Teachers
          </Button>
          <Button
            variant="default"
            size="sm"
            className="flex items-center"
            onClick={() => navigate('/timetable')}
          >
            <LayoutDashboard className="mr-2 h-4 w-4" />
            Timetable
          </Button>
        </div>
      </div>
      
      <div className="space-y-6">
        <AttendanceList />
        
        {/* Adding the Attendance Report */}
        <div className="mt-6">
          <AttendanceReport />
        </div>
      </div>
    </div>
  );
};

export default TeacherAttendance;
